import {
	fetchCrossLinksProducts,
	fetchFullProductsInfo,
	fetchProduct,
	fetchProductById,
	fetchProductsByCodes,
	fetchProductsByPropValues
} from './deprecated.api'
import { useQuery } from '@tanstack/react-query'

export const productKeys = {
	all: ['product'] as const,
	byCode: (productCode: string) => [...productKeys.all, productCode] as const,
	byId: (id: number) => [...productKeys.all, 'id', id] as const,
	crossLinks: (productCode: string) => [...productKeys.all, productCode, 'crosslinks'] as const,
	byCodes: (codes: string[]) => [...productKeys.all, 'codes', codes] as const,
	byPropValues: (propName: string, values: (string | number)[]) =>
		[...productKeys.all, 'prop', propName, values] as const
}

export const useProductQuery = (productCode: string, cookie?: string) =>
	useQuery({
		queryKey: productKeys.byCode(productCode),
		queryFn: () => fetchProduct({ productCode, cookie }),
		enabled: !!productCode
	})

export const useProductByIdQuery = (id: number) =>
	useQuery({
		queryKey: productKeys.byId(id),
		queryFn: () => fetchProductById(id),
		enabled: !!id
	})

export const useCrossLinksQuery = (productCode: string) =>
	useQuery({
		queryKey: productKeys.crossLinks(productCode),
		queryFn: () => fetchCrossLinksProducts(productCode),
		enabled: !!productCode
	})

export const useProductsByCodesQuery = (codes: string[], withDefaultFilters?: boolean) =>
	useQuery({
		queryKey: productKeys.byCodes(codes),
		queryFn: () => fetchProductsByCodes(codes, withDefaultFilters),
		enabled: codes.length > 0
	})

export const useProductsByPropValuesQuery = (
	propName: string,
	values: (string | number)[],
	withDefaultFilters?: boolean
) =>
	useQuery({
		queryKey: productKeys.byPropValues(propName, values),
		queryFn: () => fetchProductsByPropValues(propName, values, withDefaultFilters),
		enabled: !!propName && values.length > 0
	})

export const useFullProductsInfoQuery = (codes: string[]) =>
	useQuery({
		queryKey: productKeys.byCodes(codes),
		queryFn: () => fetchFullProductsInfo(codes),
		enabled: codes.length > 0
	})
